import {
  BlocksActionTypes,
  fetchBlocksFailure,
  FetchBlocksRequestAction,
  fetchBlocksSuccess,
} from "actions";
import { BlockInterface } from "interfaces/block.interface";
import { PageInterface } from "interfaces/page.interface";
import { SagaIterator } from "redux-saga";
import { call, delay, put, takeLatest } from "redux-saga/effects";
import { ApiBaseUrl } from "utils";

const fetchBlocksApi = async (page: number = 1, take: number = 10) => {
  const response = await fetch(
    ApiBaseUrl + `/api/block/all?page=${page}&take=${take}&order=desc`
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};

// Worker Saga
function* fetchBlocksData(action: FetchBlocksRequestAction): SagaIterator {
  try {
    const { page, take } = action.payload;
    const response: PageInterface<BlockInterface> = yield call(
      fetchBlocksApi,
      page,
      take
    );
    yield put(fetchBlocksSuccess(response));
  } catch (error: any) {
    yield put(fetchBlocksFailure(error.message || "Unknown error occurred"));
  }
}

function* autoReloadBlocksData(action: FetchBlocksRequestAction): SagaIterator {
  while (true) {
    yield call(fetchBlocksData, action); // call fetchBlocksData
    yield delay(10 * 1000); // Wait for 10 seconds
  }
}

// Watcher Saga
export function* watchBlocksSaga() {
  yield takeLatest(
    BlocksActionTypes.FETCH_BLOCKS_REQUEST,
    autoReloadBlocksData
  );
}
